import { liteClient as algoliasearch } from "algoliasearch/lite";

export const algoliaClient = () => {
  return algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
    process.env.NEXT_PUBLIC_ALGOLIA_API_KEY!
  );
};

export const algoliaCruiseClient = () => {
  return algoliasearch(
    process.env.NEXT_PUBLIC_CRUISE_ALGOLIA_APP_ID!,
    process.env.NEXT_PUBLIC_CRUISE_ALGOLIA_API_KEY!
  );
};
